
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.8 17H17V7.2c0-.84-.56-1.4-1.4-1.4C8.6 5.8 3 11.4 3 18.4S8.6 31 15.6 31s12.6-5.6 12.6-12.6c0-.84-.56-1.4-1.4-1.4zM17 28.06c-5.32.84-10.36-2.94-11.06-8.26C5.1 14.48 8.88 9.44 14.2 8.74v9.66c0 .84.56 1.4 1.4 1.4h9.66A9.511 9.511 0 0117 28.06zM21.2 3c-.84 0-1.4.56-1.4 1.4v8.4c0 .84.56 1.4 1.4 1.4h8.4c.84 0 1.4-.56 1.4-1.4C31 7.34 26.66 3 21.2 3zm1.4 8.4V5.94c2.8.56 4.9 2.66 5.46 5.46H22.6z","fill":"#0EA960"}})])
          )
        }
      }
    